import PartsListsTabs from './PartsListsTabs'
export default PartsListsTabs
